import { useQuery as useGetCreditReportStatus } from "@faire/web-api--source/endpoints/www/api/retailer/credit-report-status/get-hooks";
import { IRetailerCreditReport } from "@faire/web-api--source/indigofair/data/IRetailerCreditReport";

export const useGetNMIApplicationDetails = () => {
  const { data, isLoading } = useGetCreditReportStatus({
    refetchOnMount: false,
  });

  const isNoHitNMI =
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.NO_CREDIT_REPORT_FOUND ||
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.REQUEST_TIMEOUT;
  const isFrozenCreditNMI =
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.FROZEN_CREDIT_SCORE ||
    data?.detailed_credit_report_status ===
      IRetailerCreditReport.CreditReportStatus.INSUFFICIENT_CREDIT_SCORE;

  return {
    isNoHitNMI,
    isFrozenCreditNMI,
    isLoading,
  };
};
